// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"279":"dffc339ccd503f99","6906":"c483695b1a70a94e"}[chunkId] + ".css";
};